import { TripTypes } from '@model/common';
import { MediaPost } from '@model/agents/agents-social-posts-models';
import { createSelector } from 'reselect';
import { MediaPostState } from '@state/slices/agent';
import { GlobalAppState } from '@state/store';

export const getMediaPostState = (state: GlobalAppState) => state.mediaPosts;

export const getMediaPostList = createSelector(
  getMediaPostState,
  (state: MediaPostState): Array<MediaPost> => state.posts.data
);

export const getMediaPostTripTypes = createSelector(
  getMediaPostState,
  (state: MediaPostState): Array<TripTypes> => state.tripTypes.data
);

export const getIsPostListError = createSelector(
  getMediaPostState,
  (state: MediaPostState): boolean => state.posts.error !== null
);

export const getIsPostTripTypesError = createSelector(
  getMediaPostState,
  (state: MediaPostState): boolean => state.tripTypes.error !== null
);

export const getCanRenderMediaPost = createSelector(
  getMediaPostList,
  getIsPostListError,
  (mediaPosts: Array<MediaPost>, error: boolean): boolean => !!mediaPosts && !error && mediaPosts.length > 0
);

export const getCanRenderPostTripTypes = createSelector(
  getMediaPostTripTypes,
  getIsPostTripTypesError,
  (mediaPostTripTypes: Array<TripTypes>, error: boolean): boolean =>
    !!mediaPostTripTypes && !error && mediaPostTripTypes.length > 0
);
